import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/component-header";
import Footer from "./components/component-footer";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Post_blog from "./pages/Post_blog";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Thankyou from "./pages/Thankyou";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Menu from "./pages/Menu";
import Reserve from "./pages/Reserve";
import Privacy from "./pages/Privacy";
import Terms_conditions from "./pages/Terms_conditions";
import Faq from "./pages/Faq";
import Profile from "./pages/Profile";
import Page404 from "./pages/404";
import ScrollToTop from "./components/scrollToTop";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CartWrapper from "./wrappers/Cart";
import { useUserStore } from "./store/useUserStore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
function App() {
  const user = useUserStore((state) => state.user);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnmount: true,
        refetchOnReconnect: false,
        retry: 1,
        staleTime: 10000,
      },
    },
  });

  return (
    <>
      <QueryClientProvider client={queryClient}>
        {user.auth && <CartWrapper />}
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <ToastContainer position="bottom-right" />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/post/:post_id" element={<Post_blog />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/thankyou" element={<Thankyou />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/reserve" element={<Reserve />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms-conditions" element={<Terms_conditions />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </QueryClientProvider>
    </>
  );
}

export default App;
